import { getError } from "helpers/error";
import {
  Controller,
  FieldPath,
  FieldValues,
  get,
  useFormContext,
} from "react-hook-form";

import TextField from "./TextField";
import { TextFieldHookFormProps, TextFieldProps } from "./TextField.types";

const TextFieldHookForm = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  defaultValue,
  rules,
  shouldUnregister,
  setPropsWithFormState,
  setError,
  ...innerProps
}: TextFieldHookFormProps<TFieldValues, TName> & { setError?: any }) => {
  const { control } = useFormContext<TFieldValues>();

  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      control={control}
      render={(formState) => {
        const {
          field: { disabled, ref, onChange, ...innerField },
          formState: { errors },
        } = formState;
        const error = get(errors, name);
        const errorMsg = error?.message;
        const helperText =
          typeof errorMsg === "string" ? errorMsg : innerProps?.helperText;
        return (
          <TextField
            {...innerProps}
            {...innerField}
            inputRef={ref}
            error={!!error || innerProps?.error}
            helperText={helperText}
            disabled={
              typeof disabled === "boolean" ? disabled : innerProps.disabled
            }
            onChange={(e) => {
              onChange(e);
              if (setError) {
                // eslint-disable-next-line
                setError("");
              }
              // onChange as TextFieldProps["onChange"]
            }}
            {...(setPropsWithFormState?.(formState) ?? {})}
          />
        );
      }}
    />
  );
};

export default TextFieldHookForm;
